import { render, staticRenderFns } from "./apply_seo.vue?vue&type=template&id=34996d59&scoped=true"
import script from "./apply_seo.vue?vue&type=script&lang=js"
export * from "./apply_seo.vue?vue&type=script&lang=js"
import style0 from "./apply_seo.vue?vue&type=style&index=0&id=34996d59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34996d59",
  null
  
)

export default component.exports